import {
  READ_SALE_INVOICE,
  READ_SALE_CREDIT_NOTE,
  READ_PURCHASE_INVOICE,
  READ_PURCHASE_CREDIT_NOTE,
  READ_SALE_REGISTER,
  READ_PURCHASE_REGISTER,
} from '../../../constants/eInvoicePermissions';
import { formatAccessDeniedMessage } from '../../../utils/accessDeniedMessage';

const REQUIRED_SCOPE_PERMISSIONS = [
  READ_SALE_INVOICE,
  READ_SALE_CREDIT_NOTE,
  READ_PURCHASE_INVOICE,
  READ_PURCHASE_CREDIT_NOTE,
  READ_SALE_REGISTER,
  READ_PURCHASE_REGISTER,
];

export function getVatReportGenerateAccess({ hasEInvoicePermission, vatReportLabels, adminEmail }) {
  const hasAllSalesPurchaseScope = REQUIRED_SCOPE_PERMISSIONS.every((permission) => hasEInvoicePermission(permission));

  if (!hasAllSalesPurchaseScope) {
    const template =
      vatReportLabels.generate_no_sales_purchase_tooltip ??
      'You need access to both the Sales and Purchase modules to generate VAT reports. Please contact your organization admin ({email}) to update your permissions.';
    return {
      hasAllSalesPurchaseScope: false,
      tooltipMessage: formatAccessDeniedMessage(template, adminEmail),
    };
  }

  return {
    hasAllSalesPurchaseScope: true,
    tooltipMessage: '',
  };
}
